import React, {useState} from "react"
import {useQuery, useMutation} from "@apollo/client"

import {FileSearch} from "components/backoffice/Storage/File/FileSearch"
import {BackofficePage, BackofficePanel} from "components/backoffice/Layout/BackofficePage"
import QUERY_SHOW from "graphql/Media/Show/query/showList"
import MUTATION_IMPORT from "graphql/Transcode/Import/mutation/importAdd"

export const ImportEdit = (props: any) => {
  const [type, updateType] = useState("")
  const [show, updateShow] = useState("")
  const [season, updateSeason] = useState("")
  const [episode, updateEpisode] = useState("")
  const [file, updateFile] = useState<any>(null)
  const {data: {showList = []} = {}} = useQuery(QUERY_SHOW)
  const [mutate] = useMutation(MUTATION_IMPORT)

  const showSelected = showList?.find((item: any) => item.id === show)
  const seasonSelected = showSelected?.Season?.find((item: any) => item.id === season)
  const isFormValid = type === "show" && !!episode && !!file

  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    if (!isFormValid) return
    mutate({variables: {Episode: episode, File: file?.id, Movie: null}}).catch(() => undefined)
  }

  return <BackofficePage eyebrow="Centre de traitement" title="Nouvel import" description="Associez un fichier source à un épisode du catalogue." icon="fa-file-import">
    <form onSubmit={onSubmit} className="bo-two-column-layout">
      <BackofficePanel title="Média" description="Choisissez la destination dans le catalogue." icon="fa-film">
        <div className="input-group">
          <span className="input-group-text">Type</span>
          <select name="type" className="form-control" value={type} onChange={event => updateType(event.target.value)}>
            <option value="" disabled>Choisissez un type</option>
            <option value="movie">Film</option>
            <option value="show">Série</option>
          </select>
        </div>
        {type === "show" && <>
          <div className="input-group">
            <span className="input-group-text">Série</span>
            <select name="show" className="form-control" value={show} onChange={event => updateShow(event.target.value)}>
              <option value="" disabled>Choisissez une série</option>
              {showList.map((item: any) => <option key={item.id} value={item.id}>{item.name}</option>)}
            </select>
          </div>
          {show && <div className="input-group">
            <span className="input-group-text">Saison</span>
            <select name="season" className="form-control" value={season} onChange={event => updateSeason(event.target.value)}>
              <option value="" disabled>Choisissez une saison</option>
              {showSelected?.Season?.map((item: any) => <option key={item.id} value={item.id}>{item.number}</option>)}
            </select>
          </div>}
          {season && <div className="input-group">
            <span className="input-group-text">Épisode</span>
            <select name="episode" className="form-control" value={episode} onChange={event => updateEpisode(event.target.value)}>
              <option value="" disabled>Choisissez un épisode</option>
              {seasonSelected?.Episode?.map((item: any) => <option key={item.id} value={item.id}>{item.number} — {item.name}</option>)}
            </select>
          </div>}
        </>}
      </BackofficePanel>
      <BackofficePanel title="Fichier source" description="Recherchez le fichier à traiter." icon="fa-file-video">
        <FileSearch value={file} onSelect={updateFile} />
      </BackofficePanel>
      <div className="import-batch-actions bo-grid-full">
        <span>{isFormValid ? "L'import est prêt." : "Sélectionnez un épisode et un fichier."}</span>
        <button type="submit" className="bo-primary-action" disabled={!isFormValid}><span className="fas fa-arrow-right"></span>Créer l'import</button>
      </div>
    </form>
  </BackofficePage>
}
